module.exports = __webpack_public_path__ + "static/media/ic_setting_white.ed623502.svg";